import { StoreVariableWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('StoreVariable')
export class StoreVariableNodeSchemaProvider extends SchemaProvider<StoreVariableWorkflowNode> {}
